"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyListener = exports.createListener = exports.isElementActive = exports.Listener = void 0;
var listener_item_1 = require("./listener-item");
var utils_1 = require("./utils");
var is_function_1 = require("../is-function");
var Listener = /** @class */ (function () {
    function Listener(params) {
        this.events = utils_1.getEvents(params.events);
        this.elements = utils_1.getElements(params.elements);
        this.params = params;
        this.createItems();
        this.subscribe();
        if (Array.isArray(params.listeners)) {
            params.listeners.push(this);
        }
    }
    Listener.prototype.unsubscribe = function () {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].unsubscribe();
        }
        this.items = [];
    };
    Listener.prototype.subscribe = function () {
        this.items.forEach(function (item) { return item.subscribe(); });
    };
    Listener.prototype.createItems = function () {
        this.items = [];
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var element = _a[_i];
            for (var _b = 0, _c = this.events; _b < _c.length; _b++) {
                var event_1 = _c[_b];
                this.items.push(new listener_item_1.ListenerItem(element, this.params.callback, event_1, this.params.debounce, this.params.filter, this.params.once));
            }
        }
    };
    return Listener;
}());
exports.Listener = Listener;
function isElementActive(selector) {
    return function (event) { return !!event.target.closest(selector); };
}
exports.isElementActive = isElementActive;
function createListener(params) {
    return new Listener(params);
}
exports.createListener = createListener;
function destroyListener() {
    var listeners = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        listeners[_i] = arguments[_i];
    }
    listeners.forEach(function (listener) {
        listener = Array.isArray(listener) ? listener : [listener];
        listener
            .filter(function (_listener) { return _listener && is_function_1.isFunction(_listener.unsubscribe); })
            .forEach(function (_listener) { return _listener.unsubscribe(); });
    });
}
exports.destroyListener = destroyListener;
//# sourceMappingURL=listener.js.map